<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    :viewBox="viewBox"
  >
    <path
      data-name="合体 271"
      d="M24048 24552a1 1 0 1 0-2 0v4h-4v-7h.012l4.994-3 4.986 3h.012v7l-4 .006z"
      transform="translate(-24039 -24543.001)"
      :style="{ fill: color }"
    />
  </svg>
</template>

<script>
export default {
  name: 'HelpSVG',
  props: {
    size: {
      type: String,
      default: '16px',
    },
    viewBox: {
      type: String,
      default: '0 0 16 16',
    },
    color: {
      type: String,
      default: '#c1c1c1',
    },
  },
};
</script>
